import { Api } from './Api'

class ExternalForm {
  get (customerId) {
    return fetch(Api.getBaseUrl() + 'externalform/' + customerId, Api.getOptions())
  }
}

export default ExternalForm
